import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import portalApi, {
  getPortalToken,
  portalHeaders,
  portalPath,
  setPortalToken,
} from "./portalApi";
import PortalLayout from "./PortalLayout";

// Customer portal home (user, 2026-11-05): a welcome only, no modules yet.
function PortalHome() {
  const { companyId } = useParams();
  const navigate = useNavigate();
  const [me, setMe] = useState(null);

  const logout = useCallback(() => {
    setPortalToken(companyId, null);
    navigate(portalPath(companyId, "login"), { replace: true });
  }, [companyId, navigate]);

  useEffect(() => {
    if (!getPortalToken(companyId)) {
      logout();
      return;
    }
    portalApi
      .get("/portal/me", { headers: portalHeaders(companyId) })
      .then(({ data }) => setMe(data))
      .catch(() => logout());
  }, [companyId, logout]);

  if (!me) return null;
  const name = [me.contact?.firstName, me.contact?.lastName]
    .filter(Boolean)
    .join(" ");

  return (
    <PortalLayout me={me} onLogout={logout}>
      <div className="container py-5 text-center">
        <h2 className="mb-2">Welcome{name ? `, ${name}` : ""}</h2>
        <p className="text-muted mb-1">{me.customer?.name}</p>
        <p className="text-muted">
          Your orders and documents will appear here soon.
        </p>
      </div>
    </PortalLayout>
  );
}

export default PortalHome;
